import * as config from '/theme.js';
const colors = config.colorConfig;

export default {
    dark: false,
    colors: {
        'primary': colors.primary.DEFAULT,
        'primary-darken-1': colors.primary.dark,
        'secondary': colors.secondary.DEFAULT,
        'accent': colors.accent.DEFAULT,
        'success': colors.success.DEFAULT,
        'info': colors.info.DEFAULT,
        'error': colors.error.DEFAULT,
        'warning': colors.warning.DEFAULT,
        'background': colors.canvas.DEFAULT,
        'surface': colors.surface.DEFAULT,
        'on-background': colors.ink.DEFAULT,
        'on-surface': colors.ink.DEFAULT,
    },
    variables: {
        'border-color': colors.line.DEFAULT,
    },
};
